import utils from './utils';

var getParent = utils.getParent;


export default function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent(element); parent && parent !== body; parent = getParent(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-align/es/isAncestorFixed.js
// module id = 136
// module chunks = 0 1 2 3